const profile = {
  title: "내 프로필",
  premiumBtn: "회원가입",
  orderInfoTitle: "계정 권한 정보",
  tableProduct: "제품",
  tableStatus: "상태",
  tablePermissionDate: "허가일자",
  tableValidPeriod: "유효 기간",
  validStauts: "유효",
  expiredStauts: "만료됨",
  noData: "데이터 없음",
};

export default profile;
